import { default as MuiSelect, SelectProps } from '@mui/material/Select'

interface Props extends Omit<SelectProps, 'MenuProps'> {
  className?: string
}

// There's a weird SSR hydration error with the aria-controls id generation
const SelectSingle = (props: Props) => (
  <MuiSelect
    {...props}
    SelectDisplayProps={{
      'aria-controls': undefined,
    }}
  />
)

export default SelectSingle
